<template>
  <div class="page-header">
    <div class="row d-flex justify-content-between">
      <div class="col-auto">
        <h2 class="page-title" v-html="titled" />
      </div>
      <div class="col-auto">
        <div class="row">
          <div class="col-auto px-0 desktop-only" v-if="perPage">
            <div class="input-icon">
              <span class="input-icon-addon">
                <i class="fe fe-align-left"></i>
              </span>
              <select
                class="form-control"
                v-model="filter.per_page"
                @change="action"
              >
                <option
                  v-for="(num, i) in [10, 20, 50, 'All']"
                  v-html="num"
                  :value="num"
                  :key="i"
                />
              </select>
            </div>
          </div>
          <div class="col-auto">
            <slot></slot>
          </div>
        </div>
      </div>
      <div style="margin-top: 10px" class="mobile-only">
        <input
          type="text"
          v-model="filter.keyword"
          class="form-control"
          placeholder="Cari..."
        />
      </div>
    </div>
  </div>
</template>
<script>
import helper from "@/assets/js/helper.js";
export default {
  mixins: [helper],
  props: {
    perPage: { default: false },
    title: { default: "Title" },
    filter: {
      type: Object,
      default() {
        return { per_page: 10, page: 1 };
      },
    },
    action: { function() {} },
  },
  data() {
    return {
      titled: "",
    };
  },
  methods: {
    _convertToTitle() {
      let text = this.title;
      const result = text.replace(/([A-Z])/g, " $1");
      const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
      this.titled = finalResult;
    },
  },
  mounted() {
    this._convertToTitle();
  },
};
</script>
<style scoped>
@media (min-width: 320px) {
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: flex;
  }
}
@media (min-width: 600px) {
  .desktop-only {
    display: flex;
  }
  .mobile-only {
    display: none;
  }
}
</style>